import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: 'creditCardComplete',
  initialState,
  reducers: {
    setCreditCardComplete(state, action: PayloadAction<boolean>) {
      return action.payload || initialState;
    },
  },
});

export const { setCreditCardComplete } = slice.actions;

export default slice.reducer;
